export default __webpack_public_path__ + "static/power-gem-ai-new-b6da61e65d564bc33dad434bc0d90672.webp";